<glxy-form-field required="true">
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.BUSINESS_APP_CONNECTIONS' | translate }}
  </glxy-label>
  <mat-select [formControl]="connectionsFormControl" multiple required="true">
    <mat-option *ngFor="let connection of connectionsOptions" [value]="connection.value">
      {{ connection.label | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>
